import PlaygroundSection from './PlaygroundSection';

export default PlaygroundSection;